import "./postdetails.scss";
import { useState } from "react";
import { usePostDetailLogic } from "./hooks/usePostDetailLogic";
import PostDetailHeader from "./components/PostDetailHeader";
import PostDetailContent from "./components/PostDetailContent";
import PostDetailStats from "./components/PostDetailStats";
import Comments from "../comments/Comments";
import Sharepost from "../sharepost/Sharepost";
import ReportModal from "../reportmodal/ReportModal";

const Postdetails = ({ postId }) => {
    const {
        postData,
        postLoading,
        postError,
        likesCount,
        commentCount,
        isLiked,
        isTipping, //Test
        likesLoading,
        currentUser,
        handleLike,
        handleDelete,
        getBadgeStyle,
        handleTip //Test
    } = usePostDetailLogic(postId);

    const [openSharePost, setOpenSharePost] = useState(false);

    const [reportModalOpen, setReportModalOpen] = useState(false);

    if (postLoading) return <div className="postdetails">Loading details...</div>;
    if (postError || !postData) return <div className="postdetails">Error loading details or Post not found.</div>;

    return (
        <div className="postdetails">
            <PostDetailHeader 
                post={postData}
                isOwner={postData.userId === currentUser.id}
                onDelete={handleDelete}
                onReport={() => setReportModalOpen(true)}
            />

            <div style={{
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                marginBottom: "10px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                ...getBadgeStyle(postId.type)
            }}>
                        {postId.type || "Discussion"}
            </div>

            <PostDetailContent post={postData} />

            <PostDetailStats 
                likesCount={likesCount}
                commentCount={commentCount}
                isLiked={isLiked}
                isLoadingLikes={likesLoading}
                onLike={handleLike}
                onShare={() => setOpenSharePost(true)}
                // Test
                onTipClick={handleTip}
                isTipping={isTipping}
                hasWallet={!!postData.walletAddress}
            />

            <hr />

            <Comments postId={postId} />

            {openSharePost && (
                <Sharepost 
                    setOpenShare={setOpenSharePost} 
                    postToShare={postData} 
                />
            )}

            <ReportModal 
                isOpen={reportModalOpen} 
                onClose={() => setReportModalOpen(false)} 
                targetId={postData.id} 
                targetType="POST" 
            />
        </div>
    );
};

export default Postdetails;